import { createFileRoute } from '@tanstack/react-router'
import { OnboardingPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/onboarding')({
  head: () => noIndexRouteHead('onboarding', 'fr'),
  component: OnboardingPage,
})
